import * as React from 'react';
import { Balloon } from '@alifd/next';
import {setInfoPrice} from '../../redux/reduces/skuSlice'
import { useAppSelector, useAppDispatch } from '../../redux/hooks';
import openXman from '../../common/xman';
import doLog from '../../common/log';
import SampleExpress from '../../components/actions/logistics-action/order-express';
import SampleBtn from './sample-btn';

const { useState } = React;

export default function SkuPayment ( props: any ) {
  const {type, sampleInfo, sampleInventory = {}, visitCountry, productId, i18n} = props

  const {formatPrice} = sampleInfo;
  const {samplePreferedDispatchId = ''} = sampleInventory;

  const [btnLoading, setBtnLoading] = useState(false);
  const [tipShow, setTipShow] = useState(false)


  const skuInfo = useAppSelector( state =>  state.sku[type].map);
  const quantity = Object.values(skuInfo).reduce((a: any, {number = 0}: any) => a + number, 0);

  const dispatch = useAppDispatch();
  // 设置样品价格
  dispatch(setInfoPrice({
    type,
    formatPrice,
    totalPrice: Object.values(skuInfo).filter((i:any) => i.number > 0).reduce((a: any, {price = 0,number}: any) => a + price*number, 0)
  }))

  //
  const handleSubmit = (e: { preventDefault: () => void; target: any; }) => {
    e.preventDefault();

    if ( quantity === 0 ) {
      doLog(
        '/sc.details.getSample',
        `from=opensku&type=tips&pid=${productId}`,
        );
        setTipShow( true );
        // 自动关闭
        setTimeout(() => {
          setTipShow(false)
        }, 3 * 1000);
        return;
      }
    setBtnLoading(true);
    const formDom = e.target;
    openXman(() => {
      doLog(
        '/sc.details.getSample',
        `from=opensku&type=submit&pid=${productId}`,
        );
        formDom.submit();
        setBtnLoading(false);
    }, 
    () => setBtnLoading(false))
  };

  return (
    <div className="sku-payment">
      <form
        onSubmit={handleSubmit}
        action={`//biz.alibaba.com/contract/SampleOrder.htm?tracelog=from_detail_get_sample&pageId=${window.dmtrack_pageid}`}
        method="post"
      >
        {quantity > 0 && <input type="hidden" name="data" value={JSON.stringify(Object.values(skuInfo).filter((i:any) => i.number > 0))} />}

        <SampleExpress {...props}
          // 收货地
          country={visitCountry}
          // 发货地
          dispatchId={samplePreferedDispatchId}
          quantity={quantity}>
            <SampleBtn {...props} btnLoading={btnLoading} tipShow={tipShow}/>
        </SampleExpress>
      </form>
    </div>
  );
}
